import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';

import {
	ShopBagItemContainer,
	ItemContainer,
	StoreName,
	StoreContainer,
} from './shopBagItemStyles';

import CheckoutButton from './CheckoutButton';
import ShopBagItemProduct from './ShopBagItemProduct';

const trimName = name => {
	const MAX_CHARS = 45;
	return name.length <= MAX_CHARS
		? name
		: name.split('').splice(0, MAX_CHARS).join('') + '...';
};

class ShopBagItem extends PureComponent {

	static propTypes = {
		id: PropTypes.number.isRequired, // cartId
		listing: PropTypes.object.isRequired,
		store: PropTypes.object.isRequired,
		products: PropTypes.array.isRequired,
		remove: PropTypes.func.isRequired,
		firstItem: PropTypes.bool,
		cartCount: PropTypes.number,
	};

	static defaultProps = {
		cartCount: 1,
	};

	state = {
		cartHasProducts: false,
	};

	componentDidMount() {
		this.setState({
			cartHasProducts: this.props.products.length > 0,
		});
	}

	componentDidUpdate(prevProps) {
		if (prevProps.products.length !== this.props.products.length) {
			this.setState({
				cartHasProducts: this.props.products.length > 0,
			});
		}
	}

	render() {
		const { cartHasProducts } = this.state;
		const { id: cartId, listing, store, products, remove, cartCount, firstItem } = this.props;

		const multicart = cartCount > 1;
		const showButton = !multicart || (multicart && firstItem);
		const xoLink = multicart ? `/cart/?allow_multicart=t` : `/cart/${cartId}/`;

		return (
			<ShopBagItemContainer $multicart={multicart} in={cartHasProducts} unmountOnExit={true} timeout={500}>
				<StoreContainer>
					<StoreName>{trimName(store.name)}</StoreName>
					{showButton && (
						<CheckoutButton
							href={xoLink}
							slug={listing.slug}
						/>
					)}
				</StoreContainer>
				<ItemContainer>
					<TransitionGroup component={null}>
						{products.map((cartProduct, ix) =>
							<ShopBagItemProduct
								key={`cartProduct-${cartProduct.id}`}
								ix={ix}
								cartProduct={cartProduct}
								listing={listing}
								xoLink={xoLink}
								remove={(cartProductId) => {
									if (products.length === 1) {
										// we just removed the last product so the cart should transition out of the shop bag
										this.setState({ cartHasProducts: false });
									}
									remove(cartProductId);
								}}
								store={store}
							/>
						)}
					</TransitionGroup>
				</ItemContainer>
			</ShopBagItemContainer>
		);
	}
}


export default ShopBagItem;
